import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-box" }
const _hoisted_2 = {
  class: "gfu-hd gfu-hd--h1 _mb-4",
  "data-qa": "contact-form-title"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_contact_back = _resolveComponent("contact-back")
  const _component_contact_current_group_header = _resolveComponent("contact-current-group-header")
  const _component_localize = _resolveComponent("localize")
  const _component_base_notificator = _resolveComponent("base-notificator")
  const _component_issue_box = _resolveComponent("issue-box")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_contact_back, {
      class: "_mb-3",
      onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('back')))
    }),
    _createVNode(_component_contact_current_group_header, _normalizeProps(_guardReactiveProps({ currentCategoryGroup: $props.currentCategoryGroup, currentProject: $props.currentProject })), null, 16 /* FULL_PROPS */),
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.Resources.Contact.TopicsSectionHeader), 1 /* TEXT */),
    ($options.showReminder)
      ? (_openBlock(), _createBlock(_component_base_notificator, {
          key: 0,
          type: "info",
          "can-close": false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_localize, {
              resource: _ctx.Resources.Contact.ContactSelectProjectNotification
            }, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  "format-key": "0",
                  href: "#",
                  class: "gfu-link _tdu",
                  onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.$emit('back')), ["prevent"]))
                }, _toDisplayString(_ctx.Resources.Contact.ContactSelectProjectLink), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["resource"])
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_issue_box, {
      sections: $options.issuesToDisplay,
      "project-name": $options.currentProjectName,
      "allow-search": $options.allowSearch,
      "show-icon": false,
      "search-field-label": _ctx.Resources.Contact.ContactSearchTopicsFormName,
      "search-field-placeholder": _ctx.Resources.Contact.ContactSearchTopicsFormPlaceholder,
      onSectionClick: $options.onIssueSectionClick,
      onNegativeFeedbackClick: $options.onIssueNegativeFeedbackClick
    }, null, 8 /* PROPS */, ["sections", "project-name", "allow-search", "search-field-label", "search-field-placeholder", "onSectionClick", "onNegativeFeedbackClick"]),
    _createVNode(_component_contact_back, {
      class: "_mt-3",
      onClick: _cache[2] || (_cache[2] = $event => (_ctx.$emit('back')))
    }),
    _createVNode(_component_progress_overlay, {
      sticky: true,
      visible: _ctx.isProcessing
    }, null, 8 /* PROPS */, ["visible"])
  ]))
}